import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private filterStates: { [key: string]: any } = {};
  private localStorageKey = 'filterStates';

  constructor() {
    this.loadFilterStatesFromLocalStorage(); // Load initial state from localStorage
  }

  // Save a filter state and persist it to localStorage
  setFilterState(filterKey: string, state: any): void {
    this.filterStates[filterKey] = state;
    this.saveFilterStatesToLocalStorage();
  }

  // Retrieve a specific filter state
  getFilterState(filterKey: string): any {
    return this.filterStates[filterKey] || [];
  }

  // Clear a specific filter state
  clearFilterState(filterKey: string): void {
    delete this.filterStates[filterKey];
    this.saveFilterStatesToLocalStorage();
  }

  // Clear all filter states
  clearAllFilterStates(): void {
    this.filterStates = {};
    this.saveFilterStatesToLocalStorage();
  }

  // Save all filter states to localStorage
  private saveFilterStatesToLocalStorage(): void {
    localStorage.setItem(this.localStorageKey, JSON.stringify(this.filterStates));
  }

  // Load filter states from localStorage
  private loadFilterStatesFromLocalStorage(): void {
    const storedStates = localStorage.getItem(this.localStorageKey);
    if (storedStates) {
      this.filterStates = JSON.parse(storedStates);
    }
  }
}